export default {
  enums: {
    valid: 'valid',
    invalid: 'invalid',
    enable: 'enable',
    disabled: 'disabled',
    saved: 'saved',
    confirmed: 'confirmed',
    reverted: 'reverted',
    priced: 'priced',
    notPriced: 'not priced',
    writeOffWith: 'writeOffWith',
    beingWrittenOff: 'beingWrittenOff',
  },
};
